import { render } from "./AddObjectWindow.vue?vue&type=template&id=44ce3132&scoped=true&ts=true"
import script from "./AddObjectWindow.vue?vue&type=script&lang=ts"
export * from "./AddObjectWindow.vue?vue&type=script&lang=ts"

import "./AddObjectWindow.vue?vue&type=style&index=0&id=44ce3132&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ce3132"]])

export default __exports__